import { getJapanDate } from "@/utils/queryUtils/queryUtils";
import { DateRange } from "react-day-picker";

export const hotelOverviewPatchPattern = /^hotel-(.+)-(.+)$/
const datePickerFormat = "dd LLL, yyyy";
const datePickerFormatJP = "yyyy/MM/dd";

const STORAGE_KEY = "client-session";
const todayInJapan = getJapanDate();
const checkin = new Date(todayInJapan);
checkin.setDate(checkin.getDate() + 8);
const DEFAULT_CHECKIN_DATE = checkin.toISOString().split("T")[0];

const checkout = new Date(todayInJapan);
checkout.setDate(checkout.getDate() + 9);
const DEFAULT_CHECKOUT_DATE = checkout.toISOString().split("T")[0];

const nextCheckout = new Date(checkout);
nextCheckout.setDate(nextCheckout.getDate() + 1);
const DEFAULT_NEXT_CHECKOUT_DATE = nextCheckout.toISOString().split("T")[0];

export const DEFAULT_RANGE: DateRange = {
  from: new Date(DEFAULT_CHECKIN_DATE),
  to: new Date(DEFAULT_CHECKOUT_DATE),
};
const DEFAULT_ADULTS = "1";
const ZOOM_SIZE = 14;

const MOBILE_BREAKPOINT = 767;

const AGE_OPTIONS = [
  { value: 0, label: "<1" },
  { value: 1, label: "1" },
  { value: 2, label: "2" },
  { value: 3, label: "3" },
  { value: 4, label: "4" },
  { value: 5, label: "5" },
  { value: 6, label: "6" },
  { value: 7, label: "7" },
  { value: 8, label: "8" },
  { value: 9, label: "9" },
  { value: 10, label: "10" },
  { value: 11, label: "11" },
  { value: 12, label: "12" },
];

const DEFAULT_AGE_VALUE_PLACEHOLDER = "Select Age";

const DEFAULT_HOTEL_TABS = {
  detail: "Detail",
  rooms: "Rooms",
  onsen: "Onsen",
  restaurants: "Restaurants",
  breakfast: "Breakfast",
  meetings: "Meetings",
  location: "Location",
  attractions: "Attractions",
  facilities: "Facilities",
  faq: "Faq",
  weddings: "Weddings",
  service_apartment: "Service Apartment",
  activity: "Activity",
  gallery: "gallery",
};

const DEFAULT_HOTEL_TAB_ROUTING = [
  {
    title: DEFAULT_HOTEL_TABS.detail,
    url: "",
  },
  {
    title: DEFAULT_HOTEL_TABS.rooms,
    url: "rooms-",
  },
  {
    title: DEFAULT_HOTEL_TABS.onsen,
    url: "onsen-",
  },
  {
    title: DEFAULT_HOTEL_TABS.restaurants,
    url: "restaurants-",
  },
  {
    title: DEFAULT_HOTEL_TABS.meetings,
    url: "banquets-",
  },
  {
    title: DEFAULT_HOTEL_TABS.activity,
    url: "activity-",
  },
  {
    title: DEFAULT_HOTEL_TABS.location,
    url: "location-",
  },
  {
    title: DEFAULT_HOTEL_TABS.attractions,
    url: "#attraction",
  },
  {
    title: DEFAULT_HOTEL_TABS.facilities,
    url: "facilities-",
  },
  {
    title: DEFAULT_HOTEL_TABS.faq,
    url: "faq-",
  },
  {
    title: DEFAULT_HOTEL_TABS.weddings,
    url: "#",
  },
  {
    title: DEFAULT_HOTEL_TABS.breakfast,
    url: "breakfast-",
  },
  {
    title: DEFAULT_HOTEL_TABS.gallery,
    url: "gallery-",
  },
];

enum CONTENT_STATUS {
  DRAFT = "DRAFT",
  PUBLISHED = "PUBLISHED",
}

enum SUBSCRIBE_TYPE {
  SUBSCRIBE = "Subscribe",
  OFFER_SUBSCRIBE = "Offer Subscribe",
  EXPERIENCE_SUBSCRIBE = "Experience Detail Subscribe",
  NEWS_DETALS_SUBSCRIBE = "News Detail Subscribe",
  WEDDIG_SUBSCRIBE = "Wedding Subscribe",
}

export enum API_RESPONSE_STATUS {
  SUCCESS = 200,
  CREATED = 201,
}

const videoExtensions = [".mp4", ".webm", ".ogg", ".mov"];

export {
  AGE_OPTIONS,
  CONTENT_STATUS,
  datePickerFormat,
  datePickerFormatJP,
  DEFAULT_ADULTS,
  DEFAULT_CHECKIN_DATE,
  DEFAULT_CHECKOUT_DATE,
  DEFAULT_HOTEL_TAB_ROUTING,
  DEFAULT_HOTEL_TABS,
  DEFAULT_NEXT_CHECKOUT_DATE,
  MOBILE_BREAKPOINT,
  STORAGE_KEY,
  SUBSCRIBE_TYPE,
  videoExtensions,
  ZOOM_SIZE,
  DEFAULT_AGE_VALUE_PLACEHOLDER,
};

export const REGEX_PHONE_NUMBER = /^\d*$/;

export const NEWS_PER_PAGE_SIZE = 10;

export const LATEST_NEW_LIMIT = 4;

export const HEADER_LOCALE_NAME = "X-NEXT-INTL-LOCALE";

export const COOKIE_NAME = "NEXT_LOCALE";

export const BrandFormatByItemName: Record<string, string> = {
  "HOTEL MYSTAYS PREMIER": "Mystays Premier",
  "ART HOTEL": "Art Hotel",
  "KAMENOI HOTEL": "Kamenoi Hotel",
  "HOTEL MYSTAYS": "Mystays",
  "FlexStay Inn": "Flexstay",
  MyCube: "MyCube",
  "CRM Middle List Datasource": "Mystays Collection",
};
export const CRM_MIDDLE_LIST_DATASOURCE_ITEM_NAME =
  "CRM Middle List Datasource";

export const GUEST_ROOMS_SUBPAGE_ITEM_NAME = "Rooms";

// Strapi Document IDs - These are fixed IDs for singleton or configuration entries
export const STRAPI_DOCUMENT_IDS = {
  HOME_BRAND: "43b8124e716a193dd9165297", // Home brand configuration page
  BRAND_ICON_MIDDLE: "98d2b6b08e7c9198dd87a922", // Brand icon middle section
  PREMIER_RESIDENCE: "61c5fc778d1604e8d018f95e", // Premier residence page
  REGION_BRIEF_DATASOURCE: "3832bac8415d40109d55b883", // Region brief datasource
  NEARBY_HOTELS_LABEL: "82f42ce1e305cdee4b5f71eb", // Nearby hotels label
} as const;

export const BREAKPOINT_MOBILE = 768;
export const BREAKPOINT_TABLET = 1024;

export const OMAKASE_BED_TYPE = "お部屋タイプおまかせ";

export const DESTINATION_FIND_PASSION_PAGE_CONTENT =
  "日本であなたの情熱を見つける";

export const DESTINATION_FIND_PASSION_PAGE_DUMMY_DATA = [
  {
    documentId: "onsen-1",
    title: "Top destination for Onsen",
    cloudflare_url:
      "https://imagedelivery.net/Ahwf2rDz3ZiXm1qkpDKg1w/live/-/media/B3002A62D64F4EC6875E7B7AA344B7B6.jpg/public",
  },
  {
    documentId: "food-2",
    title: "Best cities for food",
    cloudflare_url:
      "https://imagedelivery.net/Ahwf2rDz3ZiXm1qkpDKg1w/live/-/media/B3002A62D64F4EC6875E7B7AA344B7B6.jpg/public",
  },
  {
    documentId: "beach-3",
    title: "Beautiful Beaches",
    cloudflare_url:
      "https://imagedelivery.net/Ahwf2rDz3ZiXm1qkpDKg1w/live/-/media/B3002A62D64F4EC6875E7B7AA344B7B6.jpg/public",
  },
  {
    documentId: "castle-4",
    title: "Castle and Temple",
    cloudflare_url:
      "https://imagedelivery.net/Ahwf2rDz3ZiXm1qkpDKg1w/live/-/media/B3002A62D64F4EC6875E7B7AA344B7B6.jpg/public",
  },
  {
    documentId: "parks-5",
    title: "Wonderful Parks",
    cloudflare_url:
      "https://imagedelivery.net/Ahwf2rDz3ZiXm1qkpDKg1w/live/-/media/B3002A62D64F4EC6875E7B7AA344B7B6.jpg/public",
  },
];

export const CANCELLATION_PAGE_TITLE_DATASOURCE_ID = "00a1090a6eab1a74b7e8f178";

export const CANCELLATION_PAGE_CANCELLATION_DATASOURCE_ID =
  "cfd9a49d209b986a2cc83077";

export const CANCELLATION_PAGE_DYNAMIC_HTML_DATASOURCES_ID =
  "e2ef363472ec6c6d161b6c3d";

export const PROFILE_DRAWER_USER_MANAGEMENT = "ユーザー管理";

const ABSOLUTE_MYSTAYS_PATH = String.raw`https:\/\/www\.mystays\.com\/(?:[a-z]{2}-[a-z]{2}\/)?[^"']*`;
const RELATIVE_PATH = String.raw`(?:\.\.?\/)+[^"']*`;
const INTERNAL_PATH = String.raw`(?!(?:https?:)?\/\/|www\.|\/)[^"']+`;
const ALLOWED_HREF_PATTERN = `(?:${[
  ABSOLUTE_MYSTAYS_PATH,
  RELATIVE_PATH,
  INTERNAL_PATH,
].join("|")})`;
const ANCHOR_PATTERN = `<a([^>]*)(href=["']${ALLOWED_HREF_PATTERN}["'])([^>]*?)>`;
export const ANCHOR_REGEX = new RegExp(ANCHOR_PATTERN, "gi");

export const GLOBAL = "Global";

export const ROOM_UNIT_LABELS = {
  SQUARE_METERS: "m²",
  TATAMI_MATS: "畳",
} as const;

export const hotelDetailPatchPattern = {
  locationPattern: /^location-(.+)-(.+)$/,
  restaurantPattern: /^restaurants-(.+)-(.+)$/,
  roomPattern: /^rooms-(.+)-(.+)$/,
  banquetPattern: /^banquets-(.+)-(.+)$/,
  facilitiesPattern: /^facilities-(.+)-(.+)$/,
  onsenPattern: /^onsen-hotel-(.+)-(.+)$/,
  poolSpaPattern: /^pool-spa-hotel-(.+)-(.+)$/,
  activityPattern: /^activity-(.+)-(.+)$/,
};

// Japan region names for map
export const JAPAN_REGION_NAMES = {
  HOKKAIDO: "北海道",
  TOHOKU: "東北地方",
  KANTO: "関東地方",
  CHUBU: "中部地方",
  KANSAI: "関西地方",
  CHUGOKU: "中国地方",
  SHIKOKU: "四国地方",
  KYUSHU_OKINAWA: "九州・沖縄地方",
} as const;

// Page titles and labels
export const PAGE_LABELS = {
  CHOOSE_CITY: "都市を選択",
  FACILITIES: "館内施設",
  LOCATION_DETAIL: "場所の詳細",
} as const;

// Default SEO metadata
export const DEFAULT_SEO_METADATA = {
  TITLE: "マイステイズ",
  DESCRIPTION: "マイステイズ - 日本全国の快適なホテルをお探しください",
} as const;
